module.exports = __webpack_public_path__ + "img/515f0c0.jpg";